import hisaab from '../../assets/hisaab1.png'
import foodapp from '../../assets/appDev.png'

export var projectsData=[
    {
        title:"CodeChat",
        links:['https://codechat-8oqw.onrender.com/','https://github.com/RamGoel/CodeChat'],
        image:'',
        category:"nodejs",
        technologies:['ejs','nodejs','socketio','bootstrap'],
        points:['Allows users to chat & code at one place.','Multi Language compiler using API','Group as well as Personal Chats']
    },
   
    {
        title:"Kalakriti",
        links:['https://kalakriti-pwa.netlify.app/','https://github.com/RamGoel/kalakriti-web'],
        image:'',
        category:"reactjs",
        technologies:['react','firebase'],
        points:['MarketPlace for Indian Artists','Google Sign in using Firebase','Under Development']
    },
    {
        title:"Portify",
        links:['https://portify.onrender.com/','https://github.com/RamGoel/portify'],
        image:'',
        category:"nodejs",
        technologies:['ejs','firebase','bootstrap', 'mongodb'],
        points:['Create Portfolio Website in 3 Minutes','Google Sign in using Firebase','Simple & Effective Design']
    },
    {
        title:"FeedWell",
        links:['https://feedwell1.netlify.app/','https://github.com/RamGoel/raj-it-day'],
        image:'',
        category:"reactjs",
        technologies:['reactjs','firebase'],
        points:['Food Quality Reviews for Govenment Schools','Authentication using Firebase','Built for IT Day Hackathon']
    },
    {
        title:"Orgarch",
        links:['https://orgarch.netlify.app/','https://github.com/RamGoel/orgarch'],
        image:'',
        category:"reactjs",
        technologies:['reactjs','firebase'],
        points:['Organize Research Conferences Easily','Authentication using Firebase','Built for IT Day Hackathon']
    },
    {
        title:"CryptoTracker",
        links:['https://crypto-hunter.netlify.app/','https://github.com/RamGoel/cryptotracker-app'],
        image:'',
        category:"reactjs",
        technologies:['reactjs','api'],
        points:['Allows Tracking of Cryptocurrencies','Data Representation using Charts','Clean and Beautiful UI']
    },
    {
        title:"Food App Design",
        links:[`https://www.figma.com/file/JjrTx7OxwdvlPQa9AmLVJk/Ram's-Workbook?node-id=79-4941`],
        image:foodapp,
        category:"Design",
        technologies:['figma'],
        points:['Created for a France based client on Fiverr','Understood Requirements in first 3 days.','Delivered in approx 2 weeks']
    },
    {
        title:"Expense Tracking App ",
        links:[`https://www.figma.com/file/JjrTx7OxwdvlPQa9AmLVJk/Ram's-Workbook?node-id=1%3A49901&t=cAJZFgtYcD8DmBgd-1`],
        image:hisaab,
        category:"Design",
        technologies:['figma'],
        points:['Created for one of my app idea','To make the tracking process simple','Included PieCharts, Profiles, reports etc.']
    },
    {
        title:"cdnExtension",
        links:['https://addons.mozilla.org/en-US/firefox/addon/cdnextension/'],
        category:"Tool",
        technologies:['html','css','javascript'],
        points:['Get Popular CDN Links on top of your browser','Also have Search Functionality','Gathered Contributions in Hacktoberfest 2022']
    },
    {
        title:"reduTrap",
        links:['https://ramgoel.github.io/reduTrap/'],
        category:"Tool",
        technologies:['html', 'css','javascript'],
        points:['A Tool to Optimize Website','Import only the "bootstrap you used" ','People Contributed in Hacktoberfest']
    },
    {
        title:"TEDxABESEC",
        links:['https://tedxabesec.in/','https://github.com/tedx-abesec/tedx-2022'],
        category:"websites",
        technologies:['html', "bootstrap","javaScript"],
        points:['Created for TEDxABESEC Event 2022','Visited by 1000+ students for registration','Included Animations, Optimized Images etc.']
    },
    {
        title:"GDSC ABESEC",
        links:['https://abesec-gdsc.netlify.app/','https://github.com/RamGoel/clubwebsite'],
        category:"websites",
        technologies:['reactjs'],
        points:['Created for GDSC club','Worked in Team of 3','Used by Students to know updates.']
    },
    {
        title:"Genero",
        links:['https://genero23.netlify.app/','https://github.com/RamGoel/genero23'],
        category:"websites",
        technologies:['reactjs'],
        points:['Created for Genero Fest of ABESEC','Used for Regsitration, Updates and Info','Visited by 1500+ students']
    },

    {
        title:"SimpliCalc",
        links:['https://www.amazon.com/Sitern-SimpliCalc/dp/B0BR648T88/ref=sr_1_5?qid=1672586146&refinements=p_n_date%3A2479571011&rnid=2479567011&s=mobile-apps&sr=1-5'],
        category:"react-native",
        technologies:['react-native','jsx','javascript'],
        points:['A Calculator built in React Native','Supports Dark/Light Mode Functionality','Simple & Easy Design']
    },
    {
        title:"Doit",
        links:['https://github.com/RamGoel/todo-react-native'],
        category:"react-native",
        technologies:['react-native','jsx','javascript'],
        points:['A Todo App built in React Native','Supports GIF Animations','Simple & Beautiful Design']
    },
    {
        title:"Xibiller",
        links:['https://github.com/RamGoel/XiBiller-Stable'],
        category:"react-native",
        technologies:['react-native','firebase'],
        points:['App for Billing at MI outlets','Built during MI Ode2Code Hackathon','Implemented Forms, Auth and more']
    },
    {
        title:"OTP Verify",
        links:['https://login-react-otp.netlify.app/', 'https://github.com/RamGoel/otp-verify-react'],
        category:"misc",
        technologies:['reactjs','api'],
        points:['OTP Verification Built in ReactJs','Built for a internship assignment','OTP Verified using API']
    },
    {
        title:"Employee CRUD",
        links:['https://employee-manange.netlify.app/','https://github.com/RamGoel/employee-manage-react'],
        category:"misc",
        technologies:['reactjs','api'],
        points:['CRUD App for Employee Data','Built for a internship assignment','Implemented Forms, CRUD using API']
    },
    {
        title:"NextJS Dashboard",
        links:['https://listed-app.vercel.app/','https://github.com/RamGoel/listed-app'],
        category:"misc",
        technologies:['nextjs','react-charts-js'],
        points:['Interactive Dashboard in NextJS','Built for a internship assignment','Implemented Forms, CRUD using API']
    },
    {
        title:"Docs Screen Clone",
        links:['https://docsclone1.netlify.app/','https://github.com/RamGoel/docsclone'],
        category:"misc",
        technologies:['reactjs','firebase-auth'],
        points:['Google Docs Clone built in reactjs','Built for a internship assignment','Implemented Forms, CRUD using API']
    },
]